import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addPhotos,
  deleteOneImage,
  getNoticeData,
  // getNoticeData,
  getOneNoticeData,
  updateNoticeData,
} from "../../store/notices/reducer";
import FileUploader from "../../components/common/FileUploader";
import AdminNavbar from "../../components/partial/AdminNavbar";

const EditNotice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state;
  const { title } = useParams();

  const dispatch = useDispatch();
  const OneNoticeData = useSelector(
    (state) => state.noticeReducer.OneNoticeData,
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [updatedTitle, setUpdatedTitle] = useState(title);
  const [updatedDetails, setUpdatedDetails] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isPopupChecked, setIsPopupChecked] = useState(false);
  const [updatedDays, setUpdatedDays] = useState("");

  useEffect(() => {
    dispatch(getOneNoticeData(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (OneNoticeData) {
      setUpdatedTitle(OneNoticeData.title || title);
      setUpdatedDetails(OneNoticeData.details || "");
      setIsPopupChecked(OneNoticeData.popup || false);
    }
  }, [OneNoticeData, title, isUpdated]);

  useEffect(() => {
    setIsUpdated(
      updatedTitle !== OneNoticeData?.title ||
        updatedDetails !== OneNoticeData?.details ||
        isPopupChecked !== OneNoticeData?.popup ||
        updatedDays !== OneNoticeData?.days,
    );
  }, [
    updatedTitle,
    updatedDetails,
    isPopupChecked,
    updatedDays,
    OneNoticeData,
  ]);

  const handleCheckboxChange = (e) => {
    setIsPopupChecked(e.target.checked);
  };

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage("");
  };

  const handleFilesUploaded = (files) => {
    setUploadedFiles([...files]);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    uploadedFiles.forEach((file) => {
      formData.append("photos", file);
    });

    try {
      dispatch(addPhotos(formData, id));
      setImageModal(false);
      dispatch(getOneNoticeData(id));
    } catch (error) {
      console.error("Error submitting photos:", error);
    }
  };

  const handleUpdate = () => {
    if (isUpdated) {
      const updatedNoticeData = {
        title: updatedTitle,
        details: updatedDetails,
        popup: isPopupChecked,
        days: updatedDays,
      };
      dispatch(updateNoticeData(id, updatedNoticeData))
        // .then(() => {
        //   dispatch(getNoticeData);
        // })
        .then(() => {
          dispatch(getOneNoticeData(id));
        })
        // .then(() => {
        //   window.location.reload();
        // })
        .then(() => {
          dispatch(getNoticeData);
          navigate("/nvm-admin/notice");
        });
    }
  };

  const handleDelete = (photo) => {
    if (window.confirm("Are you sure you want to delete this photo?")) {
      dispatch(deleteOneImage(id, photo)).then(() => {
        dispatch(getOneNoticeData(id));
      });
    }
  };

  if (!OneNoticeData || !OneNoticeData.photos) {
    return <div>Loading Notice data... No data found</div>;
  }

  const route = process.env.NEXT_PUBLIC_BASE_URL;

  return (
    <div className="flex flex-col md:flex-row md:items-center bg-gray-100 min-h-screen">
      <div className="lg:w-1/4 bg-white shadow-md">
        <AdminNavbar />
      </div>

      <div className="flex-1 p-6 md:flex-row">
        <div className="h-64 w-full bg-gray-200 flex items-center justify-center rounded-lg shadow-xl mb-8">
          <span className="text-3xl font-semibold text-gray-700">{title}</span>
        </div>
        <div className="flex w-full">
          <button
            className="bg-green-500 justify-end items-end m-4 p-4 rounded-lg"
            onClick={() => setImageModal(true)}
          >
            Add Images in this {title}
          </button>
        </div>
        <div className="mb-6">
          <input
            type="text"
            value={updatedTitle}
            onChange={(e) => setUpdatedTitle(e.target.value)}
            className="p-2 border border-gray-300 rounded-lg"
            placeholder="Edit Title"
          />
        </div>
        <div className="mb-6">
          <textarea
            value={updatedDetails}
            onChange={(e) => setUpdatedDetails(e.target.value)}
            className="p-2 border border-gray-300 rounded-lg w-full"
            placeholder="Edit Description"
          />
        </div>
        <div>
          <input
            type="checkbox"
            checked={isPopupChecked}
            onChange={handleCheckboxChange}
          />
          <label>Popup</label>
          {isPopupChecked && (
            <input
              type="number"
              min="1"
              className="w-full p-3 border-gray-300 rounded-md mb-4"
              placeholder="Enter number of days to show Popup"
              value={updatedDays}
              onChange={(e) => setUpdatedDays(e.target.value)}
            />
          )}
        </div>
        <div className="flex flex-wrap justify-center gap-2 lg:ap-6">
          {OneNoticeData.photos.map((photo, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg w-[50%] lg:w-[30%] p-4"
            >
              <img
                src={`${route}${photo}`}
                alt={updatedTitle}
                className="w-full h-48 object-cover rounded-lg mb-4"
                onClick={() => handleImageClick(photo)}
              />
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(photo);
                }}
                className="bg-red-500 text-white rounded px-4 py-2"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
        <button
          onClick={handleUpdate}
          disabled={!isUpdated}
          className={`${
            isUpdated ? "bg-blue-500" : "bg-gray-500"
          } text-white py-2 px-4 rounded-md mt-4`}
        >
          Update
        </button>

        {/* Modals */}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          className="fixed inset-0 flex items-center justify-center"
        >
          <div className="bg-white p-6 rounded-lg">
            <img
              src={`${route}/${currentImage}`}
              alt="Popup"
              className="w-full"
            />
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 bg-gray-200 p-2"
            >
              ✕
            </button>
          </div>
        </Modal>
        <Modal
          isOpen={imageModal}
          onRequestClose={() => setImageModal(false)}
          overlayClassName="fixed inset-0 bg-black bg-opacity-50"
          className="fixed inset-0 w-full flex items-center justify-center"
        >
          <div className="bg-white p-6 rounded-lg">
            <button
              onClick={() => setImageModal(false)}
              className="absolute top-2 right-2 bg-gray-200 p-2"
            >
              ✕
            </button>
            <FileUploader onFilesUploaded={handleFilesUploaded} allowMultiple />
            <button
              onClick={handleSubmit}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add Image
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default EditNotice;
